import { AboutMeImages } from 'src/assets/images'

const AboutMe = {
  location: {
    name: 'Location',
    description: 'Mostly found near my laptop, but located in the beautiful city of Ahmedabad, India.',
    image: AboutMeImages.location,
    gradient: { from: 'indigo', to: 'cyan' },
  },
  langauges: {
    name: 'Languages',
    description: 'Fluent in English, Hindi, and Gujarati. Basic proficiency in Marathi.',
    image: AboutMeImages.langauges,
    gradient: { from: 'teal', to: 'lime', deg: 105 },
  },
  degree: {
    name: 'Education',
    description: 'Holder of a B.Tech degree in Computer Engineering from PDEU University.',
    // description: 'I have a B.Tech degree in Computer Engineering from PDEU University.',
    image: AboutMeImages.degree,
    gradient: { from: 'indigo', to: 'cyan' },
  },
  work: {
    name: 'Work',
    description: 'Employed as a full-stack SDE at the Reliance Jio, with prior work experience at Ansorbit & Digicard.',
    // description: 'Working as a Software Engineer at renowed company Reliance Jio. Also worked at : Ansorbit & Digicard',
    image: AboutMeImages.work,
  },
}

export { AboutMe }
